const style = (theme) => ({
  paper: {
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
  },
  tableContainer: {
    overflow: 'auto',
    border: `1px solid ${theme.palette.grayF4.main}`,
    borderTop: 'none',
    boxSizing: 'border-box',
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: 0,
    minWidth: '100%',

    '.MuiCheckbox-root': {
      padding: 4,
    },
    '.MuiIconButton-root': {
      padding: 6,
    },
  },

  tableRow: {
    verticalAlign: 'top',
  },

  tableRowStriped: {
    '&:nth-child(even)>.MuiTableCell-root': {
      backgroundColor: theme.palette.bg.tableRow,
    },
  },

  tableRowBorder: {
    '>.MuiTableCell-root': {
      borderBottomColor: theme.palette.grayF4.main,
    },
  },
  tableRowBorderGrid: {
    '.MuiTableCell-root': {
      borderRight: `1px solid ${theme.palette.grayF4.main}`,
      borderBottom: `1px solid ${theme.palette.grayF4.main}`,
      borderLeft: 'none',
      borderTop: 'none',
    },
  },

  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.bg.tableRow,
    },
  },

  tableRowGray: {
    backgroundColor: theme.palette.bg.tableRow,
    // '>.MuiTableCell-root': {
    //   borderBottomColor: theme.palette.subText.a1,
    // },
  },

  tableCell: {
    height: 33,
    padding: '8px',
    fontSize: 14,
    lineHeight: 22 / 14,
    textAlign: 'left',
    overflow: 'hidden',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },

  tableCellCheckbox: {
    textAlign: 'center !important',
    verticalAlign: 'middle',
    width: 50,
  },

  tableCellAlignright: {
    textAlign: 'right',
  },

  tableCellAligncenter: {
    textAlign: 'center',
  },

  tableCellHighlight: {
    backgroundColor: theme.palette.bg.tableRowHighLight,
  },

  truncateCell: {
    wordBreak: 'break-word',
  },

  originText: {
    whiteSpace: 'pre-line',
    '&:not(:last-child)': {
      display: 'none !important',
    },
  },
  firstStickyRight: {
    borderLeft: `1px solid ${theme.palette.grayF4.main} !important`,
  },
})
export default style
